export enum SocialMediaPlatform {
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TIKTOK = 'tiktok',
}

export enum ReviewPlatform {
    GOOGLE = 'google',
    TRUSTPILOT = 'trustpilot',
}
